<template>

  <section>
    <div class="container blog-display">
      <div class="inner-blog">
        <div class="row">
          <div class="col-md-8">
            <div class="blog-list news_block">
              <ul>
                <li>
                  <div class="col-xs-4">
                    <div class="blog-image">
                      <img src="../assets/images/earth.jpg" class="img-responsive" alt="earth">
                    </div><!-- end blog-image -->
                  </div>
                  <div class="col-xs-8">
                    <div class="news_in blog-detail">
                      <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                        <small>DECEMBER 9, 2016<em>Chloe Parkin</em></small>
                        <h6 class="para">Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations</h6>
                    </div>
                  </div>
                  <div class="clear"></div>
                </li>
                <li>
                  <div class="col-xs-4">
                    <div class="blog-image">
                      <img src="../assets/images/earth.jpg" class="img-responsive" alt="earth">
                    </div><!-- end blog-image -->
                  </div>
                  <div class="col-xs-8">
                    <div class="news_in blog-detail">
                      <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                        <small>DECEMBER 9, 2016<em>Chloe Parkin</em></small>
                       <h6 class="para">Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations</h6>
                    </div>
                  </div>
                  <div class="clear"></div>
                </li>
                <li>
                  <div class="col-xs-4">
                    <div class="blog-image">
                      <img src="../assets/images/earth.jpg" class="img-responsive" alt="earth">
                    </div><!-- end blog-image -->
                  </div>
                  <div class="col-xs-8">
                    <div class="news_in blog-detail">
                      <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                        <small>DECEMBER 9, 2016<em>Chloe Parkin</em></small>
                       <h6 class="para">Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations</h6>
                    </div>
                  </div>
                  <div class="clear"></div>
                </li>
                <li>
                  <div class="col-xs-4">
                    <div class="blog-image">
                      <img src="../assets/images/earth.jpg" class="img-responsive" alt="earth">
                    </div><!-- end blog-image -->
                  </div>
                  <div class="col-xs-8">
                    <div class="news_in blog-detail">
                      <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                        <small>DECEMBER 9, 2016<em>Chloe Parkin</em></small>
                      <h6 class="para">Paris confronts worst wintertime pollution in 10 years with bold transport limitations Paris confronts worst wintertime pollution in 10 years with bold transport limitations</h6>

                    </div>
                  </div>
                  <div class="clear"></div>
                </li>
              </ul>
            </div><!-- end blog-list -->
            <div class="clear"></div>
            <nav aria-label="Page navigation nav-pg clearfix">
              <ul class="pagination">
              <li>
                <a href="#" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li><a href="#" class="active">1</a></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li>
                <a href="#" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
            </nav>
            <div class="clear"></div>
          </div><!-- end col -->
          <div class="col-md-4">
            <div class="posts clearfix">
              <div class="news_block latest">
                <h4>POPULAR&nbsp;POSTS</h4>
                  <ul>
                    <li>
                          <span><a href="#"><img src="../assets/images/tower.jpg" alt="tower" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">Paris confronts worst wintertime pollution in 10 years with bold transport limitations</a></p>
                              <small>DECEMBER 9, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>

                    <li>
                        <span><a href="#"><img src="../assets/images/map.jpg" alt="map" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">2 billion children breathing unsafe outdoor air worldwide</a></p>
                              <small>NOVEMBER 8, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>

                    <li>
                        <span><a href="#"><img src="../assets/images/east.jpg" alt="east" width="80" height="80"></a></span>
                          <div class="news_in col-xs-8">
                            <p><a href="#">New WHO model shows 92% of world’s population breathing dangerous air</a></p>
                              <small>OCTOBER 8, 2016</small>
                          </div>
                          <div class="clear"></div>
                      </li>
                  </ul>
              </div>
            </div>

              <div class="contribute col-xs-12">
              <p><br><span>Air pollution is everywhere.</span><br> It’s the cause behind 1 in every 8 deaths worldwide. <br> Let’s change this!</p>
              </div>
          </div><!-- end col -->
        </div><!--end row -->
      </div><!-- end inner-blog -->
    </div><!-- end blog-display -->
  </section>


</template>
<script>
import {HTTP} from '../http-common.js'

export default {
  name: 'news',
  data () {
    return {
      fetchedData: null,
      error: false,
      title : null,
      newsData : [
        {
          id : '1',
          slug: 'news1',
          title:'Hello News1',
          description:'This is description1'
        },
        {
          id : '2',
          slug: 'news2',
          title:'Hello News2',
          description:'This is description1'
        },
        {
          id : '3',
          slug: 'news3',
          title:'Hello News3',
          description:'This is description1'
        }
      ]
    }
  },
  created: function(){
      this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var url = 'pollution-weather'
                console.log(url)
                // axios.get(url).then(response => {
                //   if(response.status==200){
                //     var jsonData =response
                //     this.loading = false
                //     this.fetchedData = jsonData
                //     this.categories = this.getcategories(jsonData.data.data)
                //     this.pollutionData = this.getpollution(jsonData.data.data)
                //     this.weathersData = this.getweather(jsonData.data.data)
                //     if(jsonData.data.date==todayDate){
                //       this.pollutionTitle = "Pollution Data of Kathmandu for today"
                //       this.chartTitle = "Average Pollution Data of Kathmandu for today"
                //     }else{
                //       this.pollutionTitle = "Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                //       this.chartTitle = "Average Pollution Data of "+jsonData.data.city+" for "+jsonData.data.date
                //     }
                //     this.options.xAxis[0].categories = this.categories
                //     this.options.series[0].data = this.pollutionData
                //     this.options.series[1].data = this.weathersData
                //     this.options.title.text = this.chartTitle
                //   }
                // })
                // .catch(e => {
                //   //this.errors.push(e)
                //   this.error = true
                // })
              }
  }
}
</script>



// WEBPACK FOOTER //
// News.vue?1a2c2891